'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelInformationPage = exports.mapDispatchToProps = exports.asyncProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _class, _temp; // HotelInformation

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';


// api

// containers


// components

// // action creators


exports.mapStateToProps = mapStateToProps;
exports.applyFilters = applyFilters;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactRouterRedux = require('react-router-redux');

var _trvFedApiClient = require('../trv-fed-api-client.js');

var _trvFedApiClient2 = _interopRequireDefault(_trvFedApiClient);

var _RoomSearchBox = require('./RoomSearchBox');

var _RoomSearchBox2 = _interopRequireDefault(_RoomSearchBox);

var _GalleryViewerContainer = require('./GalleryViewerContainer');

var _GalleryViewerContainer2 = _interopRequireDefault(_GalleryViewerContainer);

var _BreadCrumb = require('../components/BreadCrumb');

var _BreadCrumb2 = _interopRequireDefault(_BreadCrumb);

var _Ellipsis = require('../components/Ellipsis');

var _Ellipsis2 = _interopRequireDefault(_Ellipsis);

var _Gallery = require('../components/Gallery');

var _Gallery2 = _interopRequireDefault(_Gallery);

var _Filters = require('../components/Filters');

var _Filters2 = _interopRequireDefault(_Filters);

var _Rooms = require('../components/Rooms');

var _Rooms2 = _interopRequireDefault(_Rooms);

var _Facilities = require('../components/Facilities');

var _Facilities2 = _interopRequireDefault(_Facilities);

var _About = require('../components/About');

var _About2 = _interopRequireDefault(_About);

var _Conditions = require('../components/Conditions');

var _Conditions2 = _interopRequireDefault(_Conditions);

var _Other = require('../components/Other');

var _Other2 = _interopRequireDefault(_Other);

var _FullWidthList = require('../components/FullWidthList');

var _FullWidthList2 = _interopRequireDefault(_FullWidthList);

var _HotelError = require('../components/HotelError');

var _HotelError2 = _interopRequireDefault(_HotelError);

var _RecommendHotels = require('../components/RecommendHotels');

var _RecommendHotels2 = _interopRequireDefault(_RecommendHotels);

var _GoogleMapPointPicker = require('../components/GoogleMapPointPicker');

var _GoogleMapPointPicker2 = _interopRequireDefault(_GoogleMapPointPicker);

var _MapModal = require('../components/MapModal');

var _MapModal2 = _interopRequireDefault(_MapModal);

var _breadcrumbs = require('../modules/breadcrumbs');

var _hotelInformation = require('../modules/hotelInformation');

var _hotels = require('../modules/hotels');

var _rooms = require('../modules/rooms');

var _filters = require('../modules/filters');

var _search = require('../modules/search');

var _exception = require('../modules/exception');

var _pageFocusedField = require('../modules/pageFocusedField');

var _galleryViewer = require('../modules/galleryViewer');

var _filters2 = require('../helpers/filters');

var _query = require('../helpers/query');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/makeomatic/redux-connect/blob/master/docs/API.MD
var asyncProps = exports.asyncProps = [{
  promise: function preload(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        location = _ref.location,
        params = _ref.params;

    var state = getState();
    var promises = [];
    var urls = state.urls,
        breadcrumbs = state.breadcrumbs;


    var ids = (0, _query.getIds)(params);
    if (!breadcrumbs.items.length || breadcrumbs.ids !== ids) {
      var types = 'hotel';
      promises.push((0, _trvFedApiClient2.default)(urls.api.breadcrumbs, 'GET', { ids: ids, types: types, category: 'multilingual' }, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 3000).then(function (res) {
        return dispatch((0, _breadcrumbs.set)((0, _extends3.default)({ ids: ids }, res)));
      }, function (res) {
        dispatch((0, _breadcrumbs.clear)());
        dispatch((0, _exception.throwException)(res.errors));
      }));
    }

    var locationQuery = (0, _query.convertLocationToState)(location.query, params).search;
    var query = (0, _extends3.default)({}, state.search, locationQuery);
    if (params.hotelID !== state.hotelInformation.id) {
      dispatch((0, _search.set)(locationQuery));
      dispatch((0, _filters.setFilters)((0, _filters2.convertToStates)(state.filters, locationQuery)));
      dispatch((0, _filters.setPriceRange)((0, _filters2.parsePrice)(location.query.price)));
      promises.push((0, _trvFedApiClient2.default)([urls.api.hotels, params.hotelID].join('/'), 'GET', query, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 8000).then(function (res) {
        dispatch((0, _hotelInformation.set)(res));
        var updatedState = getState();
        var nearbyHotelsQuery = (0, _extends3.default)({}, _lodash2.default.omitBy(query, function (val, key) {
          return key === 'country' || key === 'subdivision' || key === 'city' || key === 'spot';
        }), {
          latlng: updatedState.hotelInformation.latlng,
          radius: 2,
          stay: query.stay
        });
        return (0, _trvFedApiClient2.default)(urls.api.hotels, 'GET', nearbyHotelsQuery, state.httpRequest.req, undefined, 8000).then(function (res) {
          return dispatch((0, _hotels.set)(res));
        }, function (err) {
          console.error(err);
          dispatch((0, _hotels.clear)());
          dispatch((0, _hotels.setErrors)(err.errors));
        });
      }, function (res) {
        dispatch((0, _hotelInformation.clear)());
        if (_lodash2.default.find(res.errors, { code: 'SERVICE_UNAVAILABLE' })) {
          dispatch((0, _exception.throwException)(res.errors));
        } else {
          dispatch((0, _exception.throwException)(res.errors.map(function (error) {
            return {
              title: error.message,
              message: state.i18n.errors.searchOtherHotels,
              displaySearchForm: true
            };
          })));
        }
      }));
    }
    // XXX: there is no clear way of checking if we should fetch the nearby hotels again due to the lack of design at the beginning of the project
    //      please refactor this
    if (state.hotelInformation.latlng) {
      var nearbyHotelsQuery = (0, _extends3.default)({}, _lodash2.default.omitBy(query, function (val, key) {
        return key === 'country' || key === 'subdivision' || key === 'city' || key === 'spot';
      }), {
        latlng: state.hotelInformation.latlng,
        radius: 2,
        stay: locationQuery.stay
      });
      promises.push((0, _trvFedApiClient2.default)(urls.api.hotels, 'GET', nearbyHotelsQuery, state.httpRequest.req).then(function (res) {
        return dispatch((0, _hotels.set)(res));
      }, function (err) {
        console.error(err);
        dispatch((0, _hotels.clear)());
        dispatch((0, _hotels.setErrors)(err.errors));
      }));
    }

    dispatch((0, _search.set)(locationQuery));
    dispatch((0, _filters.setFilters)((0, _filters2.convertToStates)(state.filters.filters, location.query)));
    if (location.query.price) {
      dispatch((0, _filters.setPriceRange)((0, _filters2.parsePrice)(location.query.price)));
    } else {
      dispatch((0, _filters.clearPriceRange)());
      dispatch((0, _search.clearPrice)());
    }
    promises.push((0, _trvFedApiClient2.default)(urls.api.rooms.replace(':id', params.hotelID), 'GET', (0, _extends3.default)({}, query, { orderBy: 'price' }), state.httpRequest.req, {
      maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
      timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
    }, 8000).then(function (res) {
      dispatch((0, _rooms.set)(res));
      dispatch((0, _filters.setFilters)((0, _filters2.convertToStates)(res.filters, locationQuery)));
      dispatch((0, _filters.setPriceRange)(res.priceRange || {}));
    }).catch(function (res) {
      dispatch((0, _rooms.clear)());
      if (_lodash2.default.find(res.errors, { code: 'VALIDATION_ERROR' })) {
        dispatch((0, _search.setErrors)(res.errors));
      } else {
        dispatch((0, _exception.throwException)(res.errors));
      }
    }));

    return _promise2.default.all(promises);
  }
}];

// mapStateToprops can be either an object or a funciton
function mapStateToProps(state, ownProps) {
  var recommendHotels = state.hotels.items.filter(function (item) {
    return item.id !== state.hotelInformation.id;
  }).slice(0, 3);

  var currency = state.currencies.find(function (currency) {
    return currency.id === state.search.currency;
  }) || {};

  return {
    i18n: state.i18n,
    urls: state.urls,
    location: ownProps.location,
    breadcrumbs: state.breadcrumbs.items,
    hotelInformation: state.hotelInformation,
    rooms: state.rooms,
    recommendHotels: recommendHotels,
    nearbyHotels: state.hotels.items,
    search: state.search,
    filters: state.filters.filters,
    priceRange: state.filters.priceRange,
    params: ownProps.params,
    isMobile: !!state.httpRequest.req.useragent.isMobile,
    currency: currency
  };
}

// mapDispatchToprops can be either an object or a funciton
var mapDispatchToProps = exports.mapDispatchToProps = {
  push: _reactRouterRedux.push,
  setFocusedField: _pageFocusedField.set,
  setPriceRange: _filters.setPriceRange,
  openGalleryViewer: _galleryViewer.open,
  setActiveIndex: _galleryViewer.setActiveIndex
};
// TODO: this function is duplicated in HotelSearchPage
function applyFilters(submitted, props) {
  var search = props.search,
      location = props.location,
      push = props.push,
      setPriceRange = props.setPriceRange;

  var values = (0, _extends3.default)({}, search, (0, _filters2.convertToParams)({
    filters: submitted.filters,
    priceRange: submitted.priceRange
  }));
  setPriceRange(submitted.priceRange);
  push({
    pathname: location.pathname,
    query: (0, _query.convertStateToLocationQuery)({ search: values })
  });
}

var HotelInformationPage = exports.HotelInformationPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HotelInformationPage, _Component);

  function HotelInformationPage(props) {
    (0, _classCallCheck3.default)(this, HotelInformationPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HotelInformationPage.__proto__ || (0, _getPrototypeOf2.default)(HotelInformationPage)).call(this, props));

    _this.state = {
      isMapOpen: false
    };

    _this.closeMap = _this.closeMap.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(HotelInformationPage, [{
    key: 'openMap',
    value: function openMap(e) {
      e.preventDefault();

      this.setState({ isMapOpen: true });
    }
  }, {
    key: 'closeMap',
    value: function closeMap() {
      this.setState({ isMapOpen: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          location = _props.location,
          urls = _props.urls,
          i18n = _props.i18n,
          breadcrumbs = _props.breadcrumbs,
          hotelInformation = _props.hotelInformation,
          rooms = _props.rooms,
          recommendHotels = _props.recommendHotels,
          _props$nearbyHotels = _props.nearbyHotels,
          nearbyHotels = _props$nearbyHotels === undefined ? [] : _props$nearbyHotels,
          search = _props.search,
          filters = _props.filters,
          priceRange = _props.priceRange,
          push = _props.push,
          params = _props.params,
          setFocusedField = _props.setFocusedField,
          setPriceRange = _props.setPriceRange,
          isMobile = _props.isMobile,
          openGalleryViewer = _props.openGalleryViewer,
          currency = _props.currency,
          setActiveIndex = _props.setActiveIndex;
      var isMapOpen = this.state.isMapOpen;


      return _react2.default.createElement(
        'div',
        { id: 'content', className: 'area-layout02 layout-fluid' },
        _react2.default.createElement(_BreadCrumb2.default, { items: breadcrumbs, location: location }),
        _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-basic-info' },
          _react2.default.createElement(
            'div',
            { className: 'fluid-name-address' },
            _react2.default.createElement(
              'h1',
              {
                id: 'hotel-name',
                className: 'hotel-name-main',
                itemProp: 'name'
              },
              hotelInformation.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'hotel-rate-stars' },
              _react2.default.createElement(
                'span',
                { className: 'for-reader' },
                i18n.top.forReader.replace(/{rate}/g, (+hotelInformation.rate).toPrecision(2))
              ),
              _react2.default.createElement('span', { className: 'hotel-rate hotel-rate' + hotelInformation.rate })
            ),
            _react2.default.createElement(
              'p',
              { className: 'hotel-address' },
              _react2.default.createElement(
                'a',
                { href: true, onClick: function onClick(e) {
                    return _this2.openMap(e);
                  } },
                hotelInformation.address,
                ' ',
                _react2.default.createElement('span', { className: 'icon-hotel-address' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'fluid-review-summary' },
            _react2.default.createElement(
              'div',
              { className: 'guest-rating' },
              _react2.default.createElement(
                'span',
                null,
                i18n.top.guestRating
              ),
              _react2.default.createElement(
                'span',
                { className: 'rating-score' },
                hotelInformation.review !== '0' ? hotelInformation.review : '-'
              ),
              _react2.default.createElement(
                'span',
                null,
                '\xA0/\xA05'
              )
            )
          )
        ),
        hotelInformation.media && hotelInformation.media.length ? _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-photos' },
          _react2.default.createElement(
            'div',
            { className: 'fluid-photos-videos' },
            _react2.default.createElement(_Gallery2.default, {
              i18n: i18n,
              media: hotelInformation.media,
              isMobile: isMobile,
              onClick: function onClick(e, index) {
                e.preventDefault();
                openGalleryViewer(hotelInformation.media);
                setActiveIndex(index);
              }
            })
          )
        ) : null,
        hotelInformation.description && _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-description' },
          _react2.default.createElement(
            _Ellipsis2.default,
            { i18n: i18n, length: 300 },
            hotelInformation.description
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-vacant-search' },
          _react2.default.createElement(
            'div',
            { className: 'fluid-searchform' },
            _react2.default.createElement(_RoomSearchBox2.default, {
              hotelID: params.hotelID,
              location: location
            }),
            (!rooms.items || !rooms.items.length) && !_lodash2.default.find(filters, { checked: true }) && !priceRange.low && !priceRange.high ? _react2.default.createElement(_HotelError2.default, {
              title: i18n.errors.roomCouldNotFind,
              message: i18n.errors.pleaseSearchAgain
            }) : _react2.default.createElement(_Filters2.default, {
              i18n: i18n,
              search: search,
              types: ['roomFacility', 'meals'],
              min: +priceRange.min,
              max: +priceRange.max,
              low: +priceRange.low,
              high: +priceRange.high,
              filters: filters,
              isMobile: isMobile,
              onSubmit: function onSubmit(submitted) {
                applyFilters(submitted, { search: search, location: location, push: push, setPriceRange: setPriceRange });
              }
            })
          )
        ),
        (!rooms.items || !rooms.items.length) && (_lodash2.default.find(filters, { checked: true }) || priceRange.low || priceRange.high) ? _react2.default.createElement(_HotelError2.default, {
          title: i18n.errors.roomCouldNotFind,
          message: i18n.errors.pleaseRefreshAdditionalConditions
        }) : rooms.items && rooms.items.length ? _react2.default.createElement(_Rooms2.default, {
          i18n: i18n,
          items: rooms.items,
          isDateless:
          // XXX: Fix to more better way.
          rooms.items[0].plans[0].priceLead !== undefined,
          isMobile: isMobile,
          currency: currency,
          onPlanClick: function onPlanClick(roomId, planId) {
            if (rooms.items[0].plans[0].priceLead !== undefined) {
              if (!search.stay || search.stay.match(/\[,\d+-\d+-\d+\]/)) {
                setFocusedField({
                  hotelInfoCheckin: true,
                  hotelInfoCheckout: false
                });
              } else if (search.stay.match(/\[\d+-\d+-\d+,\]/)) {
                setFocusedField({
                  hotelInfoCheckin: false,
                  hotelInfoCheckout: true
                });
              }
            } else {
              // proceed to booking step 1
              // TODO: would be better to replace the <button> in the Plan component with <a>
              var _convertLocationToSta = (0, _query.convertLocationToState)(location.query, {}).search,
                  bed = _convertLocationToSta.bed,
                  age = _convertLocationToSta.age;

              var checkin = location.query.checkin || location.query.checkin_date || '';
              var checkout = location.query.checkout || location.query.checkout_date || '';
              var children = Number(location.query.children) ? '&children=' + location.query.children : '';
              var cBeds = bed ? '&c_beds=' + bed.split(',').join('&c_beds=') : '';
              var cAges = age ? '&c_ages=' + age.split(',').join('&c_ages=') : '';
              window.location.href = urls.external.booking + '?id_hotel=' + hotelInformation.id + '&id_plan=' + planId + '&id_room=' + roomId + '&checkin_date=' + checkin + '&checkout_date=' + checkout + '&rooms=' + location.query.rooms + '&adults=' + location.query.adults + children + cAges + cBeds;
            }
          },
          handleClick: openGalleryViewer
        }) : null,
        hotelInformation.latlng && _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-map-box' },
          _react2.default.createElement(
            'div',
            { className: 'hotel-map' },
            _react2.default.createElement(
              'div',
              {
                id: 'hotel-page-map',
                style: {
                  // TODO: move style to CSS
                  width: '100%',
                  height: '100%'
                },
                onMouseDownCapture: function onMouseDownCapture(e) {
                  return _this2.openMap(e);
                }
              },
              _react2.default.createElement(_GoogleMapPointPicker2.default, {
                i18n: i18n,
                location: location,
                search: search,
                center: hotelInformation && hotelInformation.latlng ? hotelInformation.latlng.split(',').map(function (str) {
                  return Number(str);
                }) : undefined,
                places: [(0, _extends3.default)({}, hotelInformation, {
                  id: String(hotelInformation.id),
                  lat: Number(hotelInformation.latlng.split(',')[0]),
                  lng: Number(hotelInformation.latlng.split(',')[1]),
                  highlighted: true
                })],
                disableUserInteraction: true
              })
            )
          )
        ),
        hotelInformation.facilities ? _react2.default.createElement(
          _FullWidthList2.default,
          { i18n: i18n, type: 'facilities-info', title: 'facilities' },
          _react2.default.createElement(_Facilities2.default, { i18n: i18n, items: hotelInformation.facilities })
        ) : null,
        hotelInformation.about ? _react2.default.createElement(
          _FullWidthList2.default,
          { i18n: i18n, type: 'about', title: 'aboutHotel' },
          _react2.default.createElement(_About2.default, { i18n: i18n, about: hotelInformation.about, cards: hotelInformation.cards })
        ) : null,
        hotelInformation.notes ? _react2.default.createElement(
          _FullWidthList2.default,
          { i18n: i18n, type: 'conditions', title: 'conditions' },
          _react2.default.createElement(_Conditions2.default, { i18n: i18n, notes: hotelInformation.notes, cancelpolicies: hotelInformation.cancelpolicies })
        ) : null,
        hotelInformation.others ? _react2.default.createElement(
          _FullWidthList2.default,
          { i18n: i18n, type: 'other-info', title: 'otherInformation' },
          _react2.default.createElement(_Other2.default, { i18n: i18n, items: hotelInformation.others })
        ) : null,
        _react2.default.createElement('hr', { className: 'extra-info-border' }),
        hotelInformation.others && hotelInformation.others.accessibility ? _react2.default.createElement(
          _FullWidthList2.default,
          { i18n: i18n, type: 'activities', title: 'accessibility' },
          _react2.default.createElement(
            'div',
            { className: 'content-box' },
            _react2.default.createElement(
              'div',
              { className: 'activities-listbox' },
              _react2.default.createElement(
                'ul',
                null,
                hotelInformation.others.accessibility.map(function (item) {
                  return _react2.default.createElement(
                    'li',
                    { key: item },
                    item
                  );
                })
              )
            )
          )
        ) : null,
        _react2.default.createElement('hr', { className: 'extra-info-border' }),
        hotelInformation.others && hotelInformation.others.nearby ? _react2.default.createElement(
          _FullWidthList2.default,
          { i18n: i18n, type: 'activities', title: 'activities' },
          _react2.default.createElement(
            'div',
            { className: 'content-box' },
            _react2.default.createElement(
              'div',
              { className: 'activities-listbox' },
              _react2.default.createElement(
                'ul',
                null,
                hotelInformation.others.nearby.map(function (item) {
                  return _react2.default.createElement(
                    'li',
                    { key: item },
                    item
                  );
                })
              )
            )
          )
        ) : null,
        recommendHotels && recommendHotels.length ? _react2.default.createElement(_RecommendHotels2.default, { i18n: i18n, hotels: recommendHotels, location: location, search: search }) : null,
        hotelInformation.latlng ? _react2.default.createElement(
          _MapModal2.default,
          {
            isMapOpen: isMapOpen,
            closeMap: this.closeMap,
            mapTitle: hotelInformation.name
          },
          _react2.default.createElement(_GoogleMapPointPicker2.default, {
            i18n: i18n,
            location: location,
            search: search,
            center: hotelInformation.latlng.split(',').map(function (str) {
              return Number(str);
            }),
            places: _lodash2.default.find(nearbyHotels, { id: hotelInformation.id }) ? nearbyHotels.map(function (item) {
              return (0, _extends3.default)({}, item, {
                id: String(item.id),
                lat: Number(item.latlng.split(',')[0]),
                lng: Number(item.latlng.split(',')[1]),
                highlighted: item.id === hotelInformation.id
              });
            }) : [(0, _extends3.default)({}, hotelInformation, {
              id: String(hotelInformation.id),
              lat: Number(hotelInformation.latlng.split(',')[0]),
              lng: Number(hotelInformation.latlng.split(',')[1]),
              highlighted: true
            })].concat(nearbyHotels.map(function (item) {
              return (0, _extends3.default)({}, item, {
                id: String(item.id),
                lat: Number(item.latlng.split(',')[0]),
                lng: Number(item.latlng.split(',')[1])
              });
            })),
            noNeedToFitBounds: true
          })
        ) : null,
        _react2.default.createElement(_BreadCrumb2.default, { id: 'subfooter', items: breadcrumbs, location: location }),
        _react2.default.createElement(_GalleryViewerContainer2.default, null)
      );
    }
  }]);
  return HotelInformationPage;
}(_react.Component), _class.propTypes = {
  urls: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  breadcrumbs: _react.PropTypes.array.isRequired,
  i18n: _react.PropTypes.object.isRequired,
  hotelInformation: _react.PropTypes.object.isRequired,
  rooms: _react.PropTypes.object.isRequired,
  recommendHotels: _react.PropTypes.array,
  nearbyHotels: _react.PropTypes.array,
  search: _react.PropTypes.object.isRequired,
  filters: _react.PropTypes.array.isRequired,
  priceRange: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired,
  push: _react.PropTypes.func.isRequired,
  setPriceRange: _react.PropTypes.func.isRequired,
  isMobile: _react.PropTypes.bool,
  setFocusedField: _react.PropTypes.func.isRequired,
  openGalleryViewer: _react.PropTypes.func.isRequired,
  currency: _react.PropTypes.object.isRequired,
  setActiveIndex: _react.PropTypes.func.isRequired
}, _temp);


var asyncConnectedHotelInformation = (0, _reduxConnect.asyncConnect)(asyncProps)(HotelInformationPage);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(asyncConnectedHotelInformation);


//////////////////
// WEBPACK FOOTER
// ./src/containers/HotelInformationPage.js
// module id = 1236
// module chunks = 0